import PropTypes from "prop-types";
import React from "react";
import { Badge } from "reactstrap";

const BadgeForTable = props => {
  const { badgeColor, isPill } = props;

  return (
    <React.Fragment>
      <Badge color={`${badgeColor || 'secondary'}`} className={`font-size-12`} pill={isPill}>
        {props.children}
      </Badge>
    </React.Fragment>
  );
};

BadgeForTable.propTypes = {
  badgeColor: PropTypes.string.isRequired,
  isPill: PropTypes.bool,
  children: PropTypes.any,
};

BadgeForTable.defaultProps = {
  badgeColor: "secondary",
  isPill: true,
};

export default BadgeForTable;
